export default "__VITE_ASSET__DxC7mFh___"